<div class="ag-grid-resize-wrapper" (onResize)="handleGridContainerResized($event)">
	<ng-content></ng-content>
</div>
